<template>
  <v-bottom-sheet
    v-if="locale.currentCountry"
    :content-class="[
      'bg-ui-kit-bg-gray-0',
      'rounded-lg',
    ]"
  >
    <template #activator="{ props: bottomSheetProps }">
      <CountryListItem
        v-bind="bottomSheetProps"
        :append-icon="{
          icon: 'ui-icon-arrow-right',
          color: 'ui-kit-icon-secondary'
        }"
        :country="locale.currentCountry"
      />
    </template>

    <p class="mx-4 mt-4 mb-2 text-h6">Сменить страну сайта</p>

    <CountryLinksList />
  </v-bottom-sheet>
</template>

<script setup lang="ts">
import CountryLinksList from './CountryLinksList.vue'
import CountryListItem from './CountryListItem.vue'

const locale = useAppLocale()
</script>
